<template>
	<section class="journal-page purchases-typography" aria-label="Purchases">
		<PurchasesJournalView />
	</section>
</template>

<script setup>
import PurchasesJournalView from '@/components/journal/PurchasesJournalView.vue';
import { onMounted } from 'vue';
import { useJournalStore } from '@/stores/journal';

const journalStore = useJournalStore();
onMounted(async () => {
	await journalStore.initialize?.();
	const purchasesJournal = journalStore.journalList.find(
		(journal) => (journal.name || '').trim().toLowerCase() === 'purchases',
	);
	if (purchasesJournal?.id) {
		journalStore.setActiveJournal(purchasesJournal.id);
	}
});
</script>

<style scoped>
.journal-page {
	--box-shadow: none;
	--purchase-page-gutter: 24px;
	display: flex;
	flex-direction: column;
	padding: var(--purchase-page-gutter);
	height: 100%;
	min-width: 0;
	box-sizing: border-box;
	overflow: auto;
	background: var(--noc-background);
}
</style>
